export default "__VITE_ASSET__Wf_8cz60__"